/**
 * @Author: Lzp <liuzp@xinlongmail.com>
 * @Date: 2021-09-29 14:27:21
 * @LastEditors: Lzp
 * @LastEditTime: 2021-09-29 14:27:21
 */

import * as request from '@/utils/request'
const BASE_URL = '/v1/manage/human'
export default {
	updateHr(id,data){
		return request.put(`${BASE_URL}/edit/${id}`,data)
	},
	/* 获取三级联动 */
	getAreaList(data){
		return request.get(`/v1/area/list`,data)
	},
   getCateList(data) {
     return request.get(`/v1/temp/type/list`, data)
   },
  /**
   * getPaihuoHumanResourcesList
   * @description 查看列表
   * @author Lzp
   * @date 2021/9/29
   * @param {*} data
   * @returns
   */
  getPaihuoHumanResources(data) {
    return request.get(`${BASE_URL}/resource`, data)
  },
  getPaihuoHumanResourcesList(data) {
    return request.get(`${BASE_URL}/list`, data)
  },

  /**
   * viewPaihuoHumanResources
   * @description 详情
   * @author Lzp
   * @date 2021/9/29
   * @returns promise
   */
  viewPaihuoHumanResources(data) {
    return request.get(`${BASE_URL}/view/${data}`)
  },
  
  /**
   * examinePaihuoHumansources
   * @description 审核
   * @author Lzp
   * @date 2021/9/29
   * @param {*} data
   * @returns
   */
  examinePaihuoHumansources(id, data) {
    return request.put(`${BASE_URL}/update/${id}`, data)
  },
  
  // 获取小程序列表
  getHrMiniappList(id,data){
    return request.get(`/v1/manage/human/app/list/${id}`, data)
  },
  editHrMiniappInfo(id,data) {
    return request.post(`/v1/manage/human/app/save/${id}`, data)
  },
  createHrMiniappInfo(id,data) {
    return request.post(`/v1/manage/human/app/create/${id}`, data)
  },
  deleteHrMiniappList(id,data) {
      return request.Delete(`/v1/manage/human/app/delete/${id}`, data)
  },
}